import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Horários disponíveis", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "text-paragraph mb-0 me-2" }
const _hoisted_6 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_7 = {
  key: 0,
  class: "fa-solid fa-check fa-xl ms-auto text-secondary"
}
const _hoisted_8 = {
  key: 2,
  class: "d-flex align-items-center justify-content-center py-4",
  style: {"height":"calc(100vh - 600px)"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted" }, "Nenhum horário disponível", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "offcanvas-footer" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-0" }, "Sessão agendada"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-label mb-0" }, "Reagendamento")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Calendar, {
        showOnlyFutureDates: "",
        days: _ctx.availableDays,
        paymentMethod: _ctx.paymentMethod
      }, null, 8, ["days", "paymentMethod"]),
      _hoisted_2,
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_ctx.availableTimes.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.availableTimes, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (_ctx.handleSelectDate(item)),
                class: "d-flex align-items-center py-4 border-bottom justify-content-between cursor-pointer"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.formattedDate), 1),
                  (item.online)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Estou online"))
                    : _createCommentVNode("", true)
                ]),
                (item.date === _ctx.selectedDate)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_Button, {
          marginVertical: false,
          label: "Reagendar",
          loading: _ctx.submitting,
          disabled: !_ctx.selectedDate,
          onOnClick: _ctx.handleReschedule
        }, null, 8, ["loading", "disabled", "onOnClick"])
      ])
    ])
  ], 64))
}